// Latest Articles: category filters and pagination without reloading the page.
// Links are real URLs (?topic=&pg=), so everything still works without JS.
(function () {
  const block = document.querySelector(".latest-articles");
  if (!block || typeof berwick_vars === "undefined") return;
  const results = block.querySelector(".latest-articles__results");
  const filters = block.querySelectorAll(".latest-articles__filter");
  const setActiveFilter = topic => {
    filters.forEach(filter => {
      const isActive = filter.dataset.topic === topic;
      filter.classList.toggle("is-active", isActive);
      if (isActive) {
        filter.setAttribute("aria-current", "true");
      } else {
        filter.removeAttribute("aria-current");
      }
    });
  };
  const loadArticles = (url, push = true) => {
    const params = new URL(url, window.location.href).searchParams;
    const topic = params.get("topic") || "";
    block.classList.add("is-loading");
    setActiveFilter(topic);
    fetch(berwick_vars.ajaxurl, {
      method: "POST",
      body: new URLSearchParams({
        action: "berwick_latest_articles",
        topic: topic,
        pg: params.get("pg") || 1,
        page_id: block.dataset.pageId,
        per_page: block.dataset.perPage,
        exclude: block.dataset.exclude,
        categories: block.dataset.categories
      })
    }).then(response => response.json()).then(response => {
      if (!response.success) throw new Error("Request failed");
      results.innerHTML = response.data.html;
      if (push) history.pushState({
        latestArticles: true
      }, "", url);
      if (block.getBoundingClientRect().top < 0) {
        block.scrollIntoView({
          behavior: "smooth"
        });
      }
    }).catch(() => {
      window.location.href = url;
    }).finally(() => {
      block.classList.remove("is-loading");
    });
  };
  block.addEventListener("click", event => {
    const link = event.target.closest(".latest-articles__filter, .latest-articles__pagination a");
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey) return;
    event.preventDefault();
    loadArticles(link.href);
  });
  window.addEventListener("popstate", () => {
    loadArticles(window.location.href, false);
  });
})();

// Single post: copy link button
(function () {
  document.querySelectorAll("[data-copy-link]").forEach(button => {
    const tooltip = button.querySelector(".share-btn__tooltip");
    button.addEventListener("click", () => {
      if (!navigator.clipboard) return;
      navigator.clipboard.writeText(button.dataset.copyLink).then(() => {
        tooltip.textContent = "Link copied";
        button.classList.add("copied");
        setTimeout(() => {
          button.classList.remove("copied");
          tooltip.textContent = "";
        }, 2000);
      });
    });
  });
})();